let browserHistory = require("react-router").browserHistory;
let connect = require("react-redux").connect;
let format = require("date-fns/format");
import React from "react";

let actions = require("../actions/actions");
let CreatorRating = require("./moderation-creator-rating");

class ModerationSaveForLaterSlat extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            upload: this.props.upload
        };
    }

    getNoteStatus() {
        let noteStatus;

        if (this.props.upload.creator.important_note) {
            noteStatus = "red";
        } else {
            noteStatus = "yellow";
        }

        return noteStatus;
    }

    preventDefault(e) {
        e.preventDefault();
    }

    previewUpload(uploadId) {
        browserHistory.push(
            `/fort/modparty/save-for-later/preview/${uploadId}/`
        );
    }

    render() {
        if (this.props.upload) {
            let noteStatusColor = this.getNoteStatus();

            return (
                <div className="navbar navbar-default">
                    <div className="row">
                        <div className="creator-account-info navbar_header col-xs-3">
                            <div className="row">
                                <a
                                    href={`/fort/members/${this.props.upload.creator.id}/`}
                                    target="_blank"
                                    className="profile avatar col-xs-3"
                                >
                                    <div
                                        style={{
                                            backgroundImage: `url("${this.props.upload.creator.avatar}")`,
                                            borderRadius: "50%",
                                            width: "40px",
                                            height: "40px",
                                            backgroundSize: "40px"
                                        }}
                                    />
                                </a>
                                <div className="creator-info col-xs-9">
                                    <a
                                        href={`/fort/members/${this.props.upload.creator.id}/`}
                                        target="_blank"
                                    >
                                        <div className="creator-name">
                                            {this.props.upload.creator.name}
                                        </div>
                                        <div className="creator-email gray">
                                            {this.props.upload.creator.email}
                                        </div>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className="col-xs-6 meta">
                            <div className="row">
                                <div className="rating col-xs-3">
                                    <span className="gray">Rating</span>
                                    <CreatorRating
                                        starRating={
                                            this.props.upload.creator
                                                .star_rating
                                        }
                                        iconRating={
                                            this.props.upload.creator
                                                .icon_rating
                                        }
                                    />
                                </div>
                                <div className="uploads col-xs-2">
                                    <span className="gray">Uploads</span>
                                    <input
                                        type="text"
                                        value={this.props.upload.icon_count}
                                        className="btn btn-default total-uploads"
                                        readOnly
                                    />
                                </div>
                                <div className="saved-date col-xs-2">
                                    <span className="gray">Uploaded</span>
                                    <input
                                        type="text"
                                        value={format(
                                            new Date(
                                                this.props.upload.created_at
                                            ),
                                            "MM/D/YY"
                                        )}
                                        className="btn btn-default created-at"
                                        readOnly
                                    />
                                </div>
                                <div className="saved-by col-xs-5 black">
                                    Saved by
                                    <br />
                                    {" "}
                                    {this.props.upload.moderator.name}
                                </div>
                            </div>
                        </div>
                        <div className="col-xs-3 actions">
                            <div className="btn-group">
                                <button
                                    type="button"
                                    className={`btn btn-default ui_notes ${noteStatusColor}`}
                                    onClick={this.viewNote.bind(this)}
                                >
                                    Note
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-default ui_eye blue"
                                    onClick={this.previewUpload.bind(
                                        this,
                                        this.props.upload.id
                                    )}
                                >
                                    Preview
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-default black"
                                    onClick={this.reviewUpload.bind(this)}
                                >
                                    Review
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            );
        } else {
            return null;
        }
    }

    reviewUpload() {
        this.props.showModal(null, "REVIEW_UPLOAD_CONFIRMATION", {
            saveForLater: true,
            upload: this.props.upload
        });
    }

    viewNote() {
        this.props.showModal(null, "VIEW_NOTES", { upload: this.props.upload });
    }
}

function mapStateToProps(state, ownProps) {
    let upload, keys;

    if (state.uploads.result) {
        if (state.uploads.keys) {
            if (state.uploadsSaveForLaterSearchKeys.length > 0) {
                keys = state.uploadsSaveForLaterSearchKeys;
            } else if (state.uploadsSaveForLaterKeys.length > 0) {
                keys = state.uploadsSaveForLaterKeys;
            }

            if (keys) {
                keys.forEach(uploadId => {
                    if (ownProps.upload.id === uploadId) {
                        upload = state.uploads[uploadId];
                    }
                });
            }
        }
    }
    return { upload };
}

module.exports = connect(mapStateToProps, {
    showModal: actions.showModal
})(ModerationSaveForLaterSlat);
